import axiosClient from './axiosClient';
import { IApiBaseResponse } from '~/utils/interface/common';
import { IResponseGetTags } from '~/utils/interface/tag';

const TagApi = {
  getTags() {
    return axiosClient.get<IApiBaseResponse<IResponseGetTags>>('/api/admin/tags');
  },
};

export default TagApi;
